import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'template', 'removeRowButton', 'fields' ]

  connect() {
    for (let i = 0; i < 2; i++) {
      this.addRow()
    }
  }

  addRow() {
    const defaultRow = this.templateTarget.content.cloneNode(true);
    this.fieldsTarget.appendChild(defaultRow);
    this.removeRowButtonTarget.classList.remove('d-none');
  }

  removeRow() {
    let lastRow = this.fieldsTarget.lastElementChild;
    this.fieldsTarget.removeChild(lastRow);
    if (this.fieldsTarget.children.length == 1) {
      this.removeRowButtonTarget.classList.add('d-none');
    }
  }

}
